module.exports = __webpack_public_path__ + "img/logo.f458686e.png";